import {
    Component,
    Input,
    OnInit,
    NgZone,
    Output,
    EventEmitter
} from '@angular/core';
import { Payment_Data, payment_method, PaymentSuccessResult } from 'src/app/models/basket';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import {
    create as dropin_create,
    paypalCreateOptions,
    Dropin,
    PaymentMethodPayload
} from 'braintree-web-drop-in';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { client, dataCollector } from 'braintree-web';
import { PatientService } from 'src/app/services/patient.service';
import { ApiResult } from 'src/app/models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
    selector: 'app-payment[payment_data]',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
    @Input('payment_data')
    payment_data: Payment_Data = new Payment_Data();

    @Output('payment_success')
    payment_success: EventEmitter<PaymentSuccessResult> = new EventEmitter<PaymentSuccessResult>();

    public razor_pay_window: any;
    logo_url: string = "";
    stripe_checkout_url: string = '';
    dropinInstance: Dropin;
    paypal_obj: paypalCreateOptions = {
        flow: 'checkout',
        amount: 0,
        currency: ''
    };

    constructor(
        private readonly utilitiesService: UtilitiesService,
        private readonly zone: NgZone,
        private readonly windowRefService: WindowRefService,
        private readonly patientsService: PatientService,
        private readonly providerStateService: ProviderStateService
    ) { }

    async onEmitPaymentSuccess() {
        await this.payment_success.emit(this.payment_data.paymentSuccessData);
    }

    async ngOnInit(): Promise<void> {
        // await this.load_payment_gateway()
        this.logo_url = this.providerStateService.getLogoUrl();
    }

    async payByPaypal() {
        await this.dropinInstance
            .requestPaymentMethod()
            .then(async (payload: PaymentMethodPayload) => {
                // this.nonce = payload.nonce;
                // this.payment_token = this.nonce;
                this.payment_data.payment_token = payload.nonce;

                await this.DeviceData(this.payment_data.order_data.payment_id);
                // this.posting = false;
            })
            .catch((error) => {
                console.error(error);
                this.payment_data.paypal_gateway_error_message = error.message;
            });
    }

    private async DeviceData(clienttoken: string) {
        await client
            .create({
                authorization: clienttoken
            })
            .then(async (clientInstance) => {
                await dataCollector
                    .create({
                        client: clientInstance,
                        paypal: true
                    })
                    .then(async (dataCollectorInstance) => {
                        this.payment_data.paypal_device_data =
                            dataCollectorInstance.deviceData;
                        //submit_payment_call
                        await this.submit_transaction(payment_method.paypal);
                    })
                    .catch(async (error) => {
                        console.error(error);
                        //submit_payment_call
                        await this.submit_transaction(payment_method.paypal);
                    });
            })
            .catch(async (error) => {
                console.error(error);
                //submit_payment_call
                await this.submit_transaction(payment_method.paypal);
            });
    }

    payByRazorpay() {
        this.razor_pay_window = new this.windowRefService.nativeWindow[
            'Razorpay'
        ](this.payment_data.razorpay_options);
        this.razor_pay_window.open();
    }

    async load_payment_gateway() {
        // this.payment_data.order_data.basket
        // console.log(this.payment_data.order_data.basket,"checking basket");
        if (
            this.payment_data.order_data.basket.payment_method ==
            payment_method.razorpay
        ) {
            this.payment_data.razorpay_key =
                this.payment_data.order_data.payment_gateway_id.razor_pay_id;
            this.payment_data.is_razorpay = true;
            this.payment_data.is_paypal = false;
            this.payment_data.is_stripe = false;
            await this.razorpay();
        } else if (this.payment_data.order_data.basket.payment_method ==
            payment_method.paypal) {
            this.payment_data.is_paypal = true;
            this.payment_data.is_razorpay = false;
            this.payment_data.is_stripe = false;
            await this.paypal();
        } else {
            this.payment_data.is_stripe = true;
            this.payment_data.is_paypal = false;
            this.payment_data.is_razorpay = false;
            await this.stripe();

        }

    }

    private async razorpay() {
        await this.initRazorPay();
    }

    private async initRazorPay(): Promise<void> {
        this.payment_data.razorpay_options = {
            key: this.payment_data.razorpay_key, // add razorpay key here
            name: 'eGlobalDoctors',
            description: this.payment_data.order_data.basket.order_name,
            amount: this.payment_data.order_data.basket.raw_total * 100,
            order_id: this.payment_data.order_data.payment_id,
            image: this.payment_data.eglobaldoctors_logo, // razorpay takes amount in paisa
            prefill: {},
            notes: {},
            theme: {
                color: '#004aad'
            },
            handler: await this.paymentHandler.bind(this),
            modal: {
                ondismiss: () => {
                    this.zone.run(() => {
                        // add current page routing if payment fails
                    });
                }
            }
        };
    }

    private async paymentHandler(res: any) {
        this.zone.run(async () => {
            this.payment_data.payment_token = res.razorpay_payment_id;
            if (this.payment_data.payment_token.length > 0) {
                //submit_payment_call
                await this.submit_transaction(
                    payment_method.razorpay,
                    res.razorpay_signature
                );
            }
        });
    }

    private async paypal() {
        //this.amount = await this.getamount();
        this.paypal_obj.currency =
            this.payment_data.order_data.basket.currency_type;
        this.paypal_obj.amount = this.payment_data.order_data.basket.raw_total;

        await this.BrainTreeCreate(this.payment_data.order_data.payment_id);

        //await this.DeviceData(this.payment_id);
        //await this.SubmitTransaction("paypal");
    }

    private async stripe() {
        //this.amount = await this.getamount();
        // console.log(this.payment_data.stripe_checkout_url,"hiiii");
        window.location.href = this.payment_data.stripe_checkout_url;

        // await this.BrainTreeCreate(this.payment_data.order_data.payment_id);

        //await this.DeviceData(this.payment_id);
        //await this.SubmitTransaction("paypal");
    }

    private async BrainTreeCreate(clienttoken: string) {
        await dropin_create({
            authorization: clienttoken,
            container: '#dropin-container',
            paypal: this.paypal_obj
        })
            .then(async (dropinInstance) => {
                this.dropinInstance = dropinInstance;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    renderAmount(amount: number, currency_type: string) {
        return this.utilitiesService.getRenderedAmount(amount, currency_type);
    }

    async submit_transaction(
        paymentMethod: payment_method,
        razor_pay_signature?: string
    ) {
        this.payment_data.transaction_submit_api_result = new ApiResult(true);
        this.payment_data.final_transaction_data = {
            patient_guid: this.payment_data.order_data.basket.patient_guid,
            payment_token: this.payment_data.payment_token,
            transaction_id: this.payment_data.order_data.transaction_id,
            payment_method: paymentMethod,
            deviceData: this.payment_data.paypal_device_data,
            signature: razor_pay_signature
        };
        await this.patientsService
            .SubmitPaymentToken(this.payment_data.final_transaction_data)
            .toPromise()
            .then(async (result) => {
                this.payment_data.transaction_submit_api_result.PromiseResult =
                    result;
                this.payment_data.transaction_submit_api_result.ErrorModel =
                    result.error;
                if (result.success) {
                    this.payment_data.paymentSuccessData.consultationData = {
                        consultation_request_number:
                            result.data.consultation_request_number,
                        invoice_id: result.data.invoice_id,
                        transaction_no: result.data.transaction_no,
                        transaction_id:
                            this.payment_data.final_transaction_data
                                .transaction_id
                    };

                    await this.onEmitPaymentSuccess();
                } else {
                    this.payment_data.transaction_submit_api_result.ErrorModel =
                        result.error;
                }
                this.payment_data.transaction_submit_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.payment_data.transaction_submit_api_result.ServerError =
                    error.error;
                this.payment_data.transaction_submit_api_result.PromiseResult.success =
                    false;
                this.payment_data.transaction_submit_api_result.Posting = false;
            });
    }
    isPosting(): boolean {
        return this.payment_data.transaction_submit_api_result.Posting;
    }
}
